<template>
  <div id="buy-ticket" >
       <div style="width: 85%; display: inline-block;"> 
          <table class="ticket-form" align="center">
        <tr>
            <td colspan="4" class= "balance-row">
                <table class = 'ticket-bt-box'>
                  <tr>
                    <td style="padding: 5px;">
                      <h1 style="color: #b62626; font-weight: bold;">Balance</h1> <h1>{{formatCurrency(currentBalance.total)}} </h1>
                    </td>
                    <td style="padding: 5px;">
                      <h1 style="color: #b62626; font-weight: bold;">Your Tickets</h1> <h1>{{formatCurrency(myTickets)}}</h1>
                    </td>
                  </tr>
                </table>
            </td>
        </tr>
        <br>
        <tr>
            <td class="input-title">
                 Tickets: 
            </td>
            <td class="input-values">
                <div style="display: inline-block;">
                    <div @click="valueDown" class='value-btn'>
                        <img :src="require(`../assets/arrow-down.svg`)" class="value-btn-img" />
                    </div>
                   <div style="display: inline-block; vertical-align: super;">
                        <input type="text" placeholder="Enter Number" id="ticket-amount" align="center" v-model="ticket_amount" @keypress="amountChanged($event)"/>
                   </div>
                    <div @click="valueUp" class='value-btn'>
                        <img :src="require(`../assets/arrow-up.svg`)" class="value-btn-img" />
                    </div>
                </div>
            </td>
        </tr>
        <br>
        <tr>
          <td class="input-title">
            Price: 
          </td>
          <td>
            <div class= 'total-price'>{{formatCurrency(ticket_amount*price)}} Swiftsbucks</div>
          </td>
        </tr>
    </table>
    <br>
    <div style="width: 100%;">
        <sliderConrol class="slider-conrol" v-on:persChange="persChange($event)" v-bind:value="pers"></sliderConrol>
    </div>
    <br>
    <button-a v-bind:button_status="valid_amount*callFree" v-on:clicked="callBuyTicket" style="font-size: 40px; padding: 8px;">{{button_value}}</button-a>

       </div>
  </div>
</template>
<script>
import sliderConrol from './Slider-Conrol'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      pers: 0,
      ticket_amount: '',
      valid_amount: false,
      button_value: 'Buy Tickets'
    }
  },
  computed: Object.assign(mapState([
    'currentBalance',
    'callFree'
  ])),
  props: ['price', 'myTickets'],
  components: {
    sliderConrol
  },
  methods: {
    persChange (val) {
      this.ticket_amount = Math.floor(((this.currentBalance.total) / this.price) * (val / 100))
    },
    amountChanged (evt) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    callBuyTicket () {
      this.$emit('callBuyTicket', this.ticket_amount)
    },
    valueUp () {
      const valDigits = this.ticket_amount.toString().length
      this.ticket_amount = parseFloat(this.ticket_amount) + Math.pow(10, valDigits - 1)
    },
    valueDown () {
      const valDigits = this.ticket_amount.toString().length
      this.ticket_amount = parseFloat(this.ticket_amount) - Math.pow(10, valDigits - 1)
    }
  },
  watch: {
    ticket_amount: function (val) {
      val = parseFloat(val)
      if (val > parseFloat(this.currentBalance.total) / this.price) {
        this.persChange(100)
        this.pers = 100
      } else {
        this.pers = Math.floor((val / (parseFloat(this.currentBalance.total) / this.price)) * 100)
      }
      this.valid_amount = true
      if (val < 1) {
        this.persChange(0)
        this.valid_amount = false
      }
    },
    callFree: function () {
      if (this.callFree) {
        this.button_value = 'Buy Tickets'
        document.getElementsByClassName('balance-row')[0].classList.add('pulse')
      } else {
        document.getElementsByClassName('balance-row')[0].className = 'balance-row'
        this.button_value = 'Processing'
      }
    }
  },
  created () {
    this.ticket_amount = Math.floor((parseFloat(this.currentBalance.total) / this.price) / 10)
  }
}
</script>
<style scoped>
    #buy-ticket{
     padding: 20px;
     border-top: 2px rgb(82, 82, 82) solid;
     border-bottom: 2px rgb(82, 82, 82) solid;
     width: 100%;
     display: inline-block;
     background-color: rgba(0, 0, 0, 0.2);
     animation: scaleUp 0.3s ease-out;
    }
    td{
        height: 50px;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .balance-row{
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 10px;
        border: 2px #b62626 solid;
    }
    .ticket-form{
      padding: 15px;
    }
  .input-values{
      color: rgb(209, 209, 209);
      font-size: 20px;
      height: 50px;
      user-select: none;
      -moz-user-select: none;
      -khtml-user-select: none;
      -webkit-user-select: none;
      -o-user-select: none;
  }
  .slider-conrol{
      width: 90%;
      display: inline-block;
  }
  #ticket-amount{
      height: 100%;
      font-size: 28px;
      border-radius: 4px;
      color: white;
      background-color: rgba(0, 0, 0, 0);
      border: none;
      text-align: center;
      vertical-align: middle;
  }
  #ticket-amount:focus{
      outline: none;
  }
  .input-title{
      font-size: 20px;
      font-weight: bold;
      text-align: center;
        border-radius: 10px;
        background-color: #b62626;
  }
  .value-btn{
    display: inline-block;
    width: 70px;
    height: 100%;
    background-color:
    #b62626;
    border-radius: 6px;
    font-size: 40px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
  }
  .value-btn-img {
    width: 35px;
    vertical-align: middle;
    padding-bottom: 5px;
  }
  .balance-row.pulse {
  animation-name: pulseWhite;
  animation-duration: 0.5s;
}
.ticket-bt-box h1{
  font-size: 24px;
  margin: 0px;
}
.total-price{
  font-size: 18px;
  color: rgb(172, 172, 172);
}
@keyframes pulseWhite{
  0%{
    background-color: white;
  }
  100%{
    background-color: rgba(0, 0, 0,0);
  }
}
@keyframes scaleUp {
  0%{
    transform: scaleY(0);
  }
  100%{
    transform: scaleY(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Buy-Ticket.vue